const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

/**
 * Updates member's last_activity_at timestamp
 * @param {string} schoolId - School ID
 * @param {string} memberId - Member ID
 * @param {string} accessToken - Authentication token
 * @returns {Promise<Object>} Response data
 */
const updateMemberActivity = async (schoolId, memberId, accessToken) => {
  try {
    const response = await fetch(
      `${BACKEND_URL}/api/v1/account/memberships/${memberId}/activity`,
      {
        method: 'PATCH',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );

    if (!response.ok) {
      throw new Error(`Failed to update member activity: ${response.status}`);
    }

    const result = await response.json();
    return result;
  } catch (error) {
    console.error('Error updating member activity:', error);
    throw error;
  }
};

const memberActivityAPI = {
  updateMemberActivity,
};

export default memberActivityAPI;
